import { render, staticRenderFns } from "./cModalSunatVue.vue?vue&type=template&id=33819ac1&scoped=true"
import script from "./cModalSunatVue.vue?vue&type=script&lang=js"
export * from "./cModalSunatVue.vue?vue&type=script&lang=js"
import style0 from "./cModalSunatVue.vue?vue&type=style&index=0&id=33819ac1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33819ac1",
  null
  
)

export default component.exports